<template>

  <div class="user_edit">
    <span>{{ $t('meta_title.user.edit') }}</span>

    <div class="user_form">
      <form @submit.prevent="patch" method="post">
        <div class="form-group">
          <label for="user_firstname" class="required">{{ $t('object.user.firstname') }}</label>
          <input type="text" id="user_firstname" name="firstname" class="form-control"
                 v-model="firstname">
        </div>
        <div class="form-group">
          <label for="user_lastname" class="required">{{ $t('object.user.lastname') }}</label>
          <input type="text" id="user_lastname" name="lastname" class="form-control"
                 v-model="lastname">
        </div>
        <div class="form-group">
          <label for="user_email" class="required">{{ $t('object.user.email') }}</label>
          <input type="email" id="user_email" name="email" class="form-control"
                 v-model="email">
        </div>

        <input type="submit">
      </form>
      <router-link-guard :to="{ name: 'UserAuthorization', params: { id: id }}" :msg_slug="'object.user.authorizations'" :authorization="'user-rights_edit'"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UserEdit',
    data() {
      return {
        id: '',
        firstname: '',
        lastname: '',
        email: '',
      }
    },
    created() {
      this.id = this.$route.params.id;
      this.$http.get('user/' + this.$route.params.id)
        .then(response => {
          this.firstname = response.data.firstname
          this.lastname  = response.data.lastname
          this.email     = response.data.email
        })
    },
    methods: {
      patch() {
        this.$http.patch('user/' + this.id, {
            firstname: this.firstname,
            lastname: this.lastname,
            email: this.email,
          }, {
            redirectOnSuccess: {name: 'UserList', params: {id: this.$route.params.id}}
          }
        )
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/edit.vue